export enum RoleEnum {
  HOTEL_ADMIN = 'HOTEL_ADMIN',
  FRONTDESK = 'FRONTDESK',
}
